import { ZoomImageElement } from './zoom-image.element';

if (!window.customElements.get('zoom-image')) {
    window.customElements.define('zoom-image', ZoomImageElement);
}
